 import { readable } from 'svelte/store'

 //export const urlServeur ="https://makutu.site/ci_cicd_intra/index.php"
 const urlServeurProc = () => {
    let urlx = window.location.href;
    if (urlx.indexOf('makutu', 1) !=-1 ) {
        return "https://makutu.site/ihmkit"
    } else {
        return "http://localhost:8887/CI_moteur_Kit3"
    }

 }

export const urlServeur = urlServeurProc()+"/index.php";
export const pathImages = urlServeurProc()+"/assets/images/"
export const serveurFilm = "https://api.themoviedb.org/3/";
export const pathFilesRecettes = urlServeurProc() + "/files/recettes/";
export const pathFilesSport = urlServeurProc()+"/files/sport/";


export const tabCouleurAugmentation = {
    0: "",
    1: '#B3F383',
    2: '#78BD45',
    3: '#508E23',
    4:'#B64EEE'
}

export const tabCouleurCardInfo = [
    'blue',
    'green',
    'orange',
    'cherry',
    'red'
]

// API Themovie
export const keyFilms = "f3ac32fc8b51e46a128448adf13e7c90"
export let genreFilms = readable([
{
id: 0,
name: ""
},
{
id: 28,
name: "Action"
},
{
id: 12,
name: "Adventure"
},
{
id: 16,
name: "Animation"
},
{
id: 35,
name: "Comedy"
},
{
id: 80,
name: "Crime"
},
{
id: 99,
name: "Documentary"
},
{
id: 18,
name: "Drama"
},
{
id: 10751,
name: "Family"
},
{
id: 14,
name: "Fantasy"
},
{
id: 36,
name: "History"
},
{
id: 27,
name: "Horror"
},
{
id: 10402,
name: "Music"
},
{
id: 9648,
name: "Mystery"
},
{
id: 10749,
name: "Romance"
},
{
id: 878,
name: "Science Fiction"
},
{
id: 10770,
name: "TV Movie"
},
{
id: 53,
name: "Thriller"
},
{
id: 10752,
name: "War"
},
{
id: 37,
name: "Western"
}
])
